import { render, staticRenderFns } from "./FormExCategoryLocale.vue?vue&type=template&id=bb931a2e&scoped=true&"
import script from "./FormExCategoryLocale.vue?vue&type=script&lang=js&"
export * from "./FormExCategoryLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb931a2e",
  null
  
)

export default component.exports